import { IconDashboard, IconCases, IconUser, IconLock } from '../icons';

/**
 * Merchant portal navigation.
 *
 * `adminOnly` items are hidden from agents — the server enforces the same rule
 * with requireMerchantAdmin, so hiding here is convenience, not security.
 */
export const merchantNavItems = [
  {
    to: '/merchant/dashboard',
    label: 'Dashboard',
    icon: IconDashboard,
    title: 'Dashboard',
    description: 'Your delivery issue cases at a glance.'
  },
  {
    to: '/merchant/cases',
    label: 'Cases',
    icon: IconCases,
    title: 'Cases',
    description: 'Review delivery issues and decide what happens next.'
  },
  {
    to: '/merchant/team',
    label: 'Team',
    icon: IconUser,
    adminOnly: true,
    title: 'Team',
    description: 'The people in your account and the seats they use.'
  },
  {
    to: '/merchant/account',
    label: 'Account',
    icon: IconLock,
    title: 'Account',
    description: 'Your details and password.'
  }
];

export const merchantNavFor = (merchantRole) =>
  merchantNavItems.filter((item) => !item.adminOnly || merchantRole === 'admin');

const fallbackMeta = { title: 'ParcelBuddy', description: 'Merchant portal.' };

/**
 * A single case gets its own heading rather than inheriting "Cases" from the
 * list it was opened from — the layout owns the h1, so this is where the page
 * title for /merchant/cases/:caseId has to come from. The Cases nav item still
 * highlights, since NavLink matches the prefix.
 */
const CASE_DETAIL_PATH = /^\/merchant\/cases\/([^/]+)\/?$/;

export const getMerchantPageMeta = (pathname) => {
  const caseMatch = pathname.match(CASE_DETAIL_PATH);
  if (caseMatch) {
    return {
      title: `Case ${decodeURIComponent(caseMatch[1])}`,
      description: 'The full record, the evidence, and your decision.'
    };
  }

  return (
    merchantNavItems.find(
      (item) => pathname === item.to || pathname.startsWith(`${item.to}/`)
    ) || fallbackMeta
  );
};
